var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    page: true
  }, _obj[_vm.classId] = true, _obj )},[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"page-toolbar"},[_vm._t("toolbar")],2)]),_c('div',{staticClass:"page-content",class:{ 'has-sidebar': _vm.sidebar, 'is-focused': _vm.isPageFocused }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }